import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"

export default function LetterPrefixRender({ renderPkg }:{ renderPkg?:any }){

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "letter_prefix").settings || {}
  const parseProps = { clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata}

  const outerStyling = useRenderStyling("w-full flex flex-col mt-4 pl-4", "styleObj")
  const innerStyling = useRenderStyling("w-full flex justify-start items-start mt-1", "styleObj")
  const labelStyling = useRenderStyling("w-12", "styleObj")
  const introStyling = useRenderStyling("mt-3", "styleObj")

  const merchantDBA = parseContent({ content: "[[merchant.DBA]]", ...parseProps}).result 
  const merchantDescriptor = parseContent({ content: "[[merchant.Descriptor1]]", ...parseProps}).result 
  const merchantBusinessDescription = parseContent({ content: "[[merchant.BusinessDescription]]", ...parseProps}).result 

  return (
    <div id="mm-letter-prefix" {...outerStyling}>
      <div {...innerStyling}>
        <span {...labelStyling}>From:</span>
        <span>
          { merchantDBA}
        </span>

        { merchantDescriptor.length > 0 && (
          <span> 
            - { parseContent({ content: "[[merchant.Descriptor1]]", ...parseProps}).result}
          </span>
        )}
      </div>

      <div {...innerStyling}>
        <span {...labelStyling}>To:</span>
        <span>{ parseContent({content: "[[merchant.Processor.Name]]", ...parseProps}).result }</span>
      </div>

      <div {...innerStyling}>
        <span {...labelStyling}>RE:</span>
        <span>Chargeback Reversal</span>
      </div>

      { merchantDBA.length > 0 && merchantBusinessDescription.length > 0 && (
        <p {...introStyling}>
          { merchantDBA } offers { merchantBusinessDescription }
        </p>
      )}
    </div>
  )
}